import type { ShortVideo } from './useFetchShorts';
import type { ShortVideoProperty } from '~/core/entities/property';

/** Card só foto (`includeImagesEvery`): URL vem da galeria mapeada em `images`, não de `thumbnailUrl` do anúncio (ausente sem vídeo). */
function firstImageWatermarkUrl(property: ShortVideoProperty): string | null {
	const url = property.images?.find(img =>
		Boolean(img.watermarkUrl?.trim())
	)?.watermarkUrl;
	return url?.trim() ?? null;
}

export function propertyImages(property: {
	images?: ShortVideoProperty['images'];
}): string[] {
	return (property.images ?? [])
		.map(img => img.watermarkUrl?.trim() ?? '')
		.filter(Boolean)
		.slice(0, 10);
}

export function mapPropertyToShortVideo(
	property: ShortVideoProperty
): ShortVideo | null {
	const short = property.featuredVideos?.[0];
	if (short) {
		return {
			property,
			videoUrl: short.url,
			thumbnailUrl: short.thumbnail ?? property.thumbnailUrl ?? null,
			videoWidth: short.width,
			videoHeight: short.height
		};
	}

	const images = propertyImages(property);
	if (!images.length) return null;

	return {
		property,
		videoUrl: null,
		thumbnailUrl: images[0] ?? null,
		images,
		videoWidth: undefined,
		videoHeight: undefined
	};
}
